import { currentYear } from "@/features/no-show-late-handling/route-prices/util/GetDatesForSelect";
import {
  CustomerAgreedVolumePerformanceByYearQuery,
  CustomerAgreedVolumePerformanceByYearQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";

const query = gql`
  fragment agreedVolumePerformance on AgreedVolumePerformance {
    routePairCode
    agreedVolume
    shippedVolume
    performanceInPercent
  }

  query CustomerAgreedVolumePerformanceByYear(
    $customerNumber: Int!
    $year: Int!
  ) {
    productPrice {
      customerStatistics {
        agreedVolumePerformance(customerNumber: $customerNumber, year: $year) {
          performanceByRouteCode {
            ...agreedVolumePerformance
          }
        }
      }
    }
  }
`;

export const useAgreedVolumePerformanceByCustomer = (
  customerId: number,
  year: number
) => {
  const { loading, data } = useQuery<
    CustomerAgreedVolumePerformanceByYearQuery,
    CustomerAgreedVolumePerformanceByYearQueryVariables
  >(query, {
    variables: {
      customerNumber: customerId,
      year,
    },
  });

  return {
    loading,
    agreedVolumePerformance:
      data?.productPrice.customerStatistics.agreedVolumePerformance,
  };
};
